
import ReviewHeader from "./ReviewHeader.vue";
import UiReadMoreClamp from "~/components/UI/UiReadMoreClamp.vue";

export default {
  name: "ReviewModalContent",
  components: {
    UiReadMoreClamp,
    ReviewHeader,
  },
  props: {
    review: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
  },
};
